// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useState } from 'react';
// material
import Rating from '@mui/material/Rating';
import { alpha, styled } from '@mui/material/styles';
import { Box, Link, Card, Grid, Avatar, Typography, CardContent, CardMedia } from '@mui/material';
// utils
import { fDate } from '../../../utils/formatTime';
import { fShortenNumber } from '../../../utils/formatNumber';
import SvgIconStyle from '../../../components/SvgIconStyle';
import Iconify from '../../../components/Iconify';
import { grey } from '@mui/material/colors';
import NoParkingImage from '../../../assets/static/mock-images/covers/noparkingimage.jpg';
import { makeStyles } from '@material-ui/core';

// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
}));
const TitleStyle = styled(Link)({
  height: 'auto',
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const InfoStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  marginTop: theme.spacing(2),
  color: theme.palette.text.disabled,
  flexDirection: 'column',
}));

export default function SpacePostCard({ parkingSpace, index, userType, navigate }) {
  const classes = useStyles();
  const { name, address, revenue, imageList, vehicleDetailObj } = parkingSpace;
  const [show, setShow] = useState(false);
  // required from backend
  const ratings = 4;
  const cover_photo = imageList ? imageList[0].filePreSignedUrl : NoParkingImage;

  return (
    <Grid item xs={12}>
      <Card sx={{ position: 'relative' }}>
        <CardContent
          sx={{
            pt: 4,
          }}
        >
          <Box display={'flex'} alignItems={'center'} className={classes.root}>
            <Box marginRight={'20px'}>
              <CardMedia
                component="img"
                sx={{ minWidth: 220, width: 220, height: '100%', borderRadius: '10px', cursor: 'pointer' }}
                image={cover_photo}
                onClick={() => {
                  navigate('/dashboard/addparking', {
                    state: { id: parkingSpace.id, editMode: true, isAdmin: false, parkingSpace: parkingSpace },
                  });
                }}
              />
            </Box>
            <Box>
              <TitleStyle
                color="inherit"
                variant="subtitle2"
                underline="hover"
                sx={{
                  typography: 'h5',
                  marginBottom: 0,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  navigate('/dashboard/addparking', {
                    state: { id: parkingSpace.id, editMode: true, isAdmin: false, parkingSpace: parkingSpace },
                  });
                }}
              >
                {vehicleDetailObj?.model}
              </TitleStyle>
              <div style={{ whiteSpace: 'break-spaces', width: '80%' }}>
                <Typography
                  color={grey[500]}
                  fontWeight={'normal'}
                  variant="subtitle1"
                  sx={{ margin: 0, padding: 0, overflow: 'hidden' }}
                  gutterBottom
                  component="div"
                >
                  {address}
                </Typography>
              </div>
              {/* <InfoStyle>
                <div
                  onClick={() => {
                    navigate(`/dashboard/parkingdetails?id=${parkingSpace.id}`);
                  }}
                >
                  <Rating name="simple-controlled" value={parkingSpace.parkingSpaceRating} readOnly />
                </div>
              </InfoStyle> */}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
}
